module.exports = __webpack_public_path__ + "media/erik-lund-summertime-vlog-no-copyright-music.ce62c1c9.mp3";